class LocalizationFormCustom extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    
    if (this.elements.panel) {
      this.elements.panel.addEventListener('touchstart', (e) => e.stopPropagation());
      this.elements.panel.addEventListener('touchmove', (e) => e.stopPropagation());
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }


  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector(event) {
    event.preventDefault();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    this.elements.button.blur();
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target) && !this.elements.panel.hasAttribute('hidden')) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form-custom', LocalizationFormCustom);